export const getUndos = (state, props) => state.undo;
